<template>
  <div class="pc_goodscollect">
    <!-- <h2 class="pc_title">展品收藏</h2> -->
    <ul v-if="tableData.listnum>0">
      <li class="item_goods" 
        v-for="(item,index) in tableData.list" 
        :key="'goods'+index"
        @click="gojump(item)"
      >
        <div class="item_good_img">
          <img v-lazy="item.img_url" alt=""/>
        </div>
        <p class="goods_title">{{item.proname_cn}}</p>
        <div class="love_icon" @click.stop>
          
            <el-popconfirm
              title="确定要取消收藏吗？"
              @onConfirm='cancel(item)'
            >
              <img slot="reference" v-lazy="hrefurl+'/public/icon/like_1.png'" alt=""/>
            </el-popconfirm>
        </div>
      </li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <div v-else class="peomp_con">
      <div class="prompt_img">
        <img v-lazy="hrefurl+'/public/icon/without.png'" alt=""/>
      </div>
      <p>收藏夹空空如也，快去<span class="goods_jump" @click="()=>this.$router.push('/exhibit')">展品页</span>逛逛</p>
    </div>
    <el-pagination
      v-if="tableData.listnum>tableData.pagelistnum"
      @current-change="handleCurrentChange"
      :current-page="tableData.thispage"
      :page-size="tableData.pagelistnum"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="上一页"
      next-text="下一页"
      :total="tableData.listnum * 1"
    >
    </el-pagination>
  </div>
</template>

<script>
import { reqMyProColl, reqProCollDo } from "../../../../api";
export default {
  data(){
    return{
      tableData:{
        list:[],
        listnum:0,
        pagelistnum:20,
      }
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    async init(p=1){
      const response = await reqMyProColl(p)
      if (response.code*1==2) {//请求成功
        this.tableData={
          list:response.reslist,
          listnum:response.listnum,
          pagelistnum:response.pagelistnum
        }

      }else if(response.code*1==0){//未登录,打回首页，去登陆
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"登录失效，请重新登录")
      }else if(response.code*1==1){//未收藏
      }
    },
    gojump(item){//路由跳转
      this.$router.push('/exhibit/details/'+item.pcid+'/'+item.ocid)
    },
    async cancel(obj){//取消收藏
      const response = await reqProCollDo(obj.pcid)
      if (response.code==0) {
        let index = this.tableData.list.findIndex(item=>item.pcid==obj.pcid)
        if (index>=0) this.tableData.list.splice(index,1)
        this.success(this,'取消收藏成功！')
      }else{
        this.err(this,'请求失败，请重新尝试。。。')
      }
    },
    handleCurrentChange(a){//当前页改变时
      // 调用请求接口
      this.init(a)
    },
    
  }

}
</script>

<style scoped>
.pc_goodscollect{
  width: 100%;
}
.pc_title{
  padding: 20px 30px 0;
  font-size: 24px;
  color: #008baf;
  font-weight: 600;
}
.pc_goodscollect>ul{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.pc_goodscollect>ul>li{
  width: 260px;
  overflow: hidden;
  cursor: pointer;
}
.item_goods{
  box-shadow: 0 0 10px #aaa;
  margin-top: 26px;
  position: relative;
  background-color: white;
  box-sizing: border-box;
}
.item_good_img{
  width: 100%;
  height: 260px;
  padding: 10px;
}
.goods_title{
  text-align: center;
  padding: 4px 0 10px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 10px;
}
.love_icon{
  position: absolute;
  right: 10px;
  top: 10px;
  width: 24px;
}


.prompt_img{
  width: 200px;
  margin: 100px auto 0;
  opacity: .8;
}
.peomp_con>p{
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  padding-top: 10px;
}
.goods_jump{
  color: #008baf;
  cursor: pointer;
}

.pc_goodscollect>>>.el-pagination{
  padding: 40px 0 20px;
  text-align: center;
}
.pc_goodscollect>>>.el-pager li,
.pc_goodscollect>>>.el-pagination .btn-next, 
.pc_goodscollect>>>.el-pagination .btn-prev{
  background-color: transparent;
}


</style>